import { render, staticRenderFns } from "./OneCentralAccessView.vue?vue&type=template&id=0768ae60&scoped=true"
import script from "./OneCentralAccessView.vue?vue&type=script&lang=ts"
export * from "./OneCentralAccessView.vue?vue&type=script&lang=ts"
import style0 from "./OneCentralAccessView.vue?vue&type=style&index=0&id=0768ae60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0768ae60",
  null
  
)

export default component.exports